<template>
  <div ref="myChart" class="chart" @click="start"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      myChart: "",
      index: 0, // 秒数
      errorFlag: false,
      interval: "",
      data: [],
      fzData: [
        20, 20.9, 22.3, 23.4, 24.1, 25.2, 26.1, 27.7, 28.3, 29.8, 30.3, 31.3,
        32, 33.2, 34.7, 35.4, 36.2, 37.2, 38.6, 39.1,
      ],
      realTimeData: [
        0,
        7,
        8,
        9,
        10,
        12,
        12,
        12,
        13,
        14,
        14,
        14,
        14,
        15,
        15,
        15,
        15,
        14,
        14,
        14,
        15,
        15,
        14,
        14,
        14,
        14,
        14,
        14,
        15,
        16,
        17,
        18,
        19,
        19,
        21,
        22,
        23,
        24,
        26,
        28,
        28,
        29, //42
        31,
        31,
        31,
        32,
        33,
        34,
        34,
        35,
        36,
        37,
        38,
        39,
        39,
        40,
        41,
        42,
        42,
        42, // 0021的时候
        52, // 1
        59,
        65,
        68,
        71,
        71,
        73,
        72,
        70, //9
        69,
        67,
        64,
        62,
        58,
        56,
        52,
        50,
        47,
        45,
        44,
        42,
        39,
        38,
        37,
        35,
        35,
        34,
        32,
      ],
      startValue: 0,
      startFlag: false,
    };
  },
  methods: {
    initChart() {
      this.$nextTick(() => {
        if (this.interval) clearInterval(this.interval);
        this.data = [];
        this.data.push({
          name: 0,
          value: 0,
        });
        let fzData = [];
        let option = {
          title: {
            text: "实时温度与仿真温度",
            left: "center",
            textStyle: {
              color: "#a0e3ff",
            },
          },
          textStyle: {
            color: "#a0e3ff",
          },
          legend: {
            right: "25",
            top: "25",
            textStyle: {
              color: "#fff",
            },
          },
          xAxis: {
            type: "category",
            splitLine: {
              show: false,
            },
            data: this.data.map((f) => f.name),
          },
          yAxis: {
            type: "value",
            boundaryGap: [0, "100%"],
            splitLine: {
              show: false,
            },
          },
          series: [
            {
              name: "实时温度",
              type: "line",
              color: "orange",
              label: {
                show: true,
                position: "top",
              },
              data: this.data,
            },
            {
              name: "仿真温度",
              type: "line",
              color: "#a0e3ff",
              label: {
                show: true,
                position: "top",
              },
              data: fzData,
            },
          ],
        };

        if (this.myChart) echarts.dispose(this.myChart);
        this.myChart = echarts.init(this.$refs.myChart);
        this.myChart.setOption(option);
      });
    },
    start() {
      this.startValue = 0;
      this.index = 0;
      this.startFlag = !this.startFlag;
      if (!this.startFlag) {
        this.initChart();
        this.$emit("end");
        return;
      }
      this.startFlag = true;
      this.$emit("start");
      this.interval = setInterval(() => {
        if (this.data.length >= 20) this.data.shift();
        this.index++;
        this.startValue++;
        if (this.index >= 60) {
          this.index = 0;
          this.errorFlag = !this.errorFlag;
        }
        if (this.startValue == 87) clearInterval(this.interval);

        this.data.push({
          name: this.index,
          value: this.realTimeData[this.startValue],
        });
        this.myChart.setOption({
          xAxis: {
            data: this.data.map((f) => f.name),
          },
          series: [
            {
              data: this.data,
            },
            {
              data: this.fzData,
            },
          ],
        });
      }, 1000);
    },
  },
  mounted() {
    this.initChart();
  },
};
</script>

<style scoped>
.chart {
  height: 100%;
  width: 100%;
  cursor: pointer;
}
</style>
